export const LOAD_RESERVATION = 'LOAD_RESERVATION';
export const LOAD_RESERVATION_PENDING = 'LOAD_RESERVATION_PENDING';
export const LOAD_RESERVATION_FULFILLED = 'LOAD_RESERVATION_FULFILLED';
export const LOAD_RESERVATION_REJECTED = 'LOAD_RESERVATION_REJECTED';
export const DELETE_RESERVATION = 'DELETE_RESERVATION';
export const DELETE_RESERVATIONS = 'DELETE_RESERVATIONS';
export const CREATE_RESERVATIONS = 'CREATE_RESERVATIONS';
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
